import React, { useState } from 'react'
import '.././App.css';
import Menu from '../panel/Menu';

export default function Planexpired() {


    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <div className='row'>
                            <div className='col-sm-2'>

                            </div>
                            <div className='col-sm-8'>
                                <div className="card card-danger card-outline ">
                                        <img src='https://theskylandhotel.com/public/plan.jpeg' alt='plan' />
                                    {/* <div className="card-body text-center" >
                                        <h4>Your reacharge plan is expired</h4>
                                        <p>To continue enjoying uninterrupted services, we recommend renewing your plan as soon as possible. Please visit the front desk or contact us  for more details about our available plans and special offers.</p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >

        </div >
    )
}
